_ = require 'underscore'
CustomFieldBadgesView = require 'app/scripts/views/custom-field/custom-field-badges-view'
CustomFieldCheckboxCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-checkbox-card-detail-badge-view'
CustomFieldDateCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-date-card-detail-badge-view'
CustomFieldListCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-list-card-detail-badge-view'
CustomFieldNumberCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-number-card-detail-badge-view'
CustomFieldTextCardDetailBadgeView = require 'app/scripts/views/custom-field/custom-field-text-card-detail-badge-view'
{ trackUe } = require '@trello/analytics'

CUSTOM_FIELDS_ID = require('@trello/config').customFieldsId

viewForType = (type) ->
  switch type
    when 'checkbox' then CustomFieldCheckboxCardDetailBadgeView
    when 'date' then CustomFieldDateCardDetailBadgeView
    when 'list' then CustomFieldListCardDetailBadgeView
    when 'number' then CustomFieldNumberCardDetailBadgeView
    when 'text' then CustomFieldTextCardDetailBadgeView

module.exports = class CustomFieldCardDetailBadgesView extends CustomFieldBadgesView
  tagName: 'div'
  className: -> 'custom-field-detail-badges-grid'

  render: ->
    subviews = @model.getBoard().customFieldList.map (customField) =>
      if !customField.visible()
        return null
      customFieldItem = @model.getCustomFieldItem(customField.id)
      if !@model.editable() && customFieldItem?.isEmpty()
        return null
      if customFieldItem? || @model.editable()
        uniqId = @idForBadge(customField.toJSON(), customFieldItem?.toJSON())
        @subview viewForType(customField.get 'type'), @model, { customFieldItem, customField, sendPluginUIEvent: @options.sendPluginUIEvent }, uniqId

    compacted = _.compact(subviews)
    @ensureSubviews compacted

    if compacted.length > 0
      @trackBadges()

    @

  trackBadges: ->
    if !@trackedDetailsBadges
      @trackedDetailsBadges = true
      trackUe('card details', 'views', 'Power-Up', '', '', 'card-detail-badges', CUSTOM_FIELDS_ID)
      @options.sendPluginScreenEvent({
        idPlugin: CUSTOM_FIELDS_ID
        idBoard: @model.getBoard().id
        idCard: @model.id
        screenName: 'pupCardBackSectionInlineDialog'
      })
